import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'GOLFX',
  description:
    'The most popular AMM on BSC by user count! Earn CAC through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by GOLFX World), NFTs, and more, on a platform you can trust.',
  image: 'https://pancakeswap.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('GOLFX')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('GOLFX')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('GOLFX')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('GOLFX')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('GOLFX')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('GOLFX')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('GOLFX')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('GOLFX')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('GOLFX')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('GOLFX')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('GOLFX')}`,
      }
    default:
      return null
  }
}
